import React from 'react';
import { SkeletonBlock } from './SkeletonBlock';

interface SkeletonCircleProps {
  size?: number;
  className?: string;
}

export const SkeletonCircle: React.FC<SkeletonCircleProps> = ({ size = 40, className = '' }) => {
  return (
    <SkeletonBlock
      width={size}
      height={size}
      radius={9999}
      className={className}
    />
  );
};
